import { Injectable } from '@angular/core';
import { I18nPipe } from '@shared/pipes/i18n.pipe';
import { CommonFormatHelperService } from '@kv-common-components/kv-common-components';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root',
})
/**
 * Class service dediee au formattage des donnees destinees aux differents affichages IHM
 */
export class FormatHelperService extends CommonFormatHelperService {
    static readonly dateFormatAppointment = 'dddd DD MMMM, à HH[h]mm';

    constructor(private i18nPipeTmp: I18nPipe) {
        super(i18nPipeTmp);
    }

    /**
     * Retourne une date formatee : exemple au format DD/MM/YYYY
     *
     * @param date: date au format standard YYYY-MM-DDT00:00:00.000+01:00 a formater
     * @param type: format de la date attendue
     */
    static getDateFormatted(date: string, type: string, ddn?: boolean): string {
        if (ddn) {
            return moment.parseZone(date).utcOffset(0, true).format(type);
        } else {
            return moment(date).locale('fr').format(type);
        }
    }

    /**
     * Retourne une date formatee pour un rdv medical
     *
     * @param date: date d un rdv medical
     * @param format
     */
    static getDateFormattedForAppointment(
        date: string,
        format: string
    ): string {
        const dateFormated = moment(date).locale('fr').format(format);
        return dateFormated.charAt(0).toUpperCase() + dateFormated.slice(1);
    }

    /**
     * Retourne une date formatee a partir d un timestamp
     *
     * @param timestamp
     */
    static getDateFormattedFromTimestamp(timestamp: number): string {
        return new Date(timestamp).toLocaleDateString('fr-FR');
    }

    /**
     * Retourne une date formatee pour une invitation OutLook
     *
     * @param date: Date d un rdv medical par exemple
     */
    static getDateTimeIcsFormatted(date: string): string {
        return date.split(/[-:.]/g).join('');
    }

    /**
     * Retourne un montant formate sans chiffre apres la virgule
     *
     * @param amount: montant a formater
     */
    static getAmountFormattedNoDigit(amount: number): string {
        return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        })
            .format(amount)
            .toString();
    }

    static checkAssurance(itemByDossier: any) {
        if (!itemByDossier.emprunteur.assurance) {
            itemByDossier.emprunteur.assurance =
                itemByDossier.emprunteur.listeAssuranceSansSuite[0];
        }
    }
}
